import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
} from "react-router-dom";
import "./App.css";
import Customer_Master from "./Components/Modules/Masters/Customer/Customer_Master";
import Customers_Table from "./Components/Modules/Masters/Customer/Customers_Table";
import ItemMaster from "./Components/Modules/Masters/ItemMaster/ItemMaster";
import ItemMasterTable from "./Components/Modules/Masters/ItemMaster/ItemMasterTable";
import Supplier_Master from "./Components/Modules/Masters/Supplier/Supplier_Master";
import Supplier_Table from "./Components/Modules/Masters/Supplier/Supplier_Table";
import EstimateReport from "./Components/Modules/Reports/EstimateReport/EstimateReport";
import PdfGeneratorRoute from "./Components/Modules/Transactions/PDF/PdfGeneratorRoute";
import PurchaseOrderReport from "./Components/Modules/Reports/PurchaseOrderReport/PurchaseOrderReport";
import PurchaseBalanceReport from "./Components/Modules/Reports/PurchaseBalanceReport/PurchaseBalanceReport";
import PurchaseReport from "./Components/Modules/Reports/PurchaseReport/PurchaseReport";
import RepairsReport from "./Components/Modules/Reports/RepairsReport/RepairsReport";
import SalesBalanceReport from "./Components/Modules/Reports/SalesBalanceReport/SalesBalanceReport";
import SalesReport from "./Components/Modules/Reports/SalesReport/SalesReport";
import URDPurchaseReport from "./Components/Modules/Reports/URDPurchaseReport/URDPurchase";
import EODDashboard from "./Components/Modules/Reports/EODDashboard/EODDashboard";
import Estimate from "./Components/Modules/Transactions/Estimate/EstimatesForm/EstimateForm";
import EstimateTable from "./Components/Modules/Transactions/Estimate/EstimateTable";
import EstimateFormV2 from "./Components/Modules/Transactions/Estimate/v2/EstimateFormV2";
import EstimateTableV2 from "./Components/Modules/Transactions/Estimate/v2/EstimateTableV2";
import Payments from "./Components/Modules/Transactions/Payments/Payments";
import Purchase from "./Components/Modules/Transactions/Purchase/Purchase";
import PurchaseTable from "./Components/Modules/Transactions/Purchase/PurchaseTable";
import PurchaseTable1 from "./Components/Modules/Transactions/Purchase/PurchaseTable1";
import OrderReceipts from "./Components/Modules/Transactions/Receipts/OrderReceipts";
import Receipts from "./Components/Modules/Transactions/Receipts/Receipts";
import ReceiptsTable from "./Components/Modules/Transactions/Receipts/ReceiptsTable";
import Repairs from "./Components/Modules/Transactions/Repairs/Repairs";
import RepairsTable from "./Components/Modules/Transactions/Repairs/RepairsTable";
import RepairsView from "./Components/Modules/Transactions/Repairs/RepairsView";
import StockEntry from "./Components/Modules/Transactions/StockEntry/StockEntry";
import StockEntryTable from "./Components/Modules/Transactions/StockEntry/StockEntryTable";
import URDPurchase from "./Components/Modules/Transactions/URDPurchase/URDPurchase";
import Dashboard from "./Components/Pages/Dashboard/Dashboard";
import usePageTitle from "./hooks/usePageTitle";
import Navbar from "./Navbar/Navbar";
import Login from "./Components/Pages/Login/Login";
// import PaymentsTable from './Components/Modules/Transactions/Payments/PaymentsTable';
import Accounts from "./Components/Modules/Masters/Accounts/Accounts";
import AccountsTable from "./Components/Modules/Masters/Accounts/AccountsTable";
import PaymentsTable from "./Components/Modules/Transactions/Purchase/PurchasePaymentTable";
// import Sales from './Components/Modules/Transactions/Sales/SalesForm';
import Company_Info from "./Components/Modules/Masters/CompanyInfo/CompanyInfo";
import DesignMaster from "./Components/Modules/Masters/DesignMaster/DesignMaster";
import MetalType from "./Components/Modules/Masters/MetalType/MetalType";
import Purity from "./Components/Modules/Masters/Purity/Purity";
import PurityTable from "./Components/Modules/Masters/Purity/PurityTable";
import Rates from "./Components/Modules/Masters/Rates/Rates";
import RatesData from "./Components/Modules/Masters/RatesData/RatesData";
import OrdersTable from "./Components/Modules/Transactions/Orders/OrdersTable";
import SalesTable from "./Components/Modules/Transactions/Sales/SalesTable";
import Sales from "./Components/Modules/Transactions/SalesForm/SalesForm";
import URDPurchasetable from "./Components/Modules/Transactions/URDPurchase/URDPurchasetable";
// import Orders from './Components/Modules/Transactions/Orders/Orders';
import Festoffers from "./Components/Modules/Masters/FestivalOffers/FestOffers";
import Festofferstable from "./Components/Modules/Masters/FestivalOffers/FestOffersTable";
import SubCategory from "./Components/Modules/Masters/SubCategory/SubCategory";
import SubCategoryV2 from "./Components/Modules/Masters/SubCategory/SubCategoryV2";
import SubCategoryTable from "./Components/Modules/Masters/SubCategory/SubCategoryTable";
import UserMaster from "./Components/Modules/Masters/UserMaster/UserMaster";
import UserMasterTable from "./Components/Modules/Masters/UserMaster/UserMasterTable";
import Worker_Master from "./Components/Modules/Masters/Worker/Worker";
import Worker_Table from "./Components/Modules/Masters/Worker/WorkerTable";
import BarCodePrinting from "./Components/Modules/Reports/BarcodePrinting/BarCodePrinting";
import ItemSales from "./Components/Modules/Reports/ItemSale/ItemSale";
import EstimateReceipt from "./Components/Modules/Transactions/Estimate/EstimateReceipt";
import Orders from "./Components/Modules/Transactions/OrderSection/OrderForm";
import PurchasePayment from "./Components/Modules/Transactions/Purchase/PurchasePayment";
import RateCuts from "./Components/Modules/Transactions/Purchase/RateCuts";
import EstimateSales from "./Components/Modules/Transactions/Sales/EstimateSales";
import RepairDetails from "./Components/Modules/Transactions/Sales/SalesDetailsModules";
import SalesNew from "./Components/Modules/Transactions/Sales/SalesNew";
import SalesReturn from "./Components/Modules/Transactions/SalesReturn/SalesForm";
import AccountDetails from "./Components/Pages/Dashboard/AccountDetails";
import Receivables from "./Components/Pages/Dashboard/Payables";
import { AuthProvider } from "./Components/Pages/Login/Context";
import QRScanner from "./Components/QRScanner";
import OrderProductsPage from "./Components/Modules/Transactions/Orders/OrderAssignment";
import VendorAssignments from "./Components/Modules/Transactions/Orders/VendorAssignments";
import VendorSubmissions from "./Components/Modules/Transactions/Orders/VendorSubmissions";
import AdminReviews from "./Components/Modules/Transactions/Orders/AdminReviews";
import SubmissionView from "./Components/Modules/Transactions/Orders/SubmissionView";

function App() {
  const location = useLocation();

  // Use the custom hook to set dynamic page titles
  usePageTitle();

  // Check if the current route is login or signup
  const isAuthPage = location.pathname === "/" || location.pathname === "/";

  return (
    <>
      <AuthProvider>
        {!isAuthPage && <Navbar />}
        <Routes>
          <Route path="/" exact element={<Login />} />
          <Route path="/dashboard" exact element={<Dashboard />} />
          <Route path="/itemmaster" exact element={<ItemMaster />} />
          <Route path="/repairs" element={<Repairs />} />
          <Route path="/repairs/:id" element={<Repairs />} />
          <Route path="/repairsview/:id" element={<RepairsView />} />
          <Route path="/repairstable" element={<RepairsTable />} />
          <Route path="/urd_purchase" element={<URDPurchase />} />
          <Route path="/itemmastertable" element={<ItemMasterTable />} />
          <Route path="/estimates/" element={<Estimate />} />
          <Route path="/estimates/v2/" element={<EstimateFormV2 />} />
          <Route path="/estimatetable" element={<EstimateTable />} />
          <Route path="/estimatetable/v2" element={<EstimateTableV2 />} />
          <Route path="/suppliertable" element={<Supplier_Table />} />
          <Route path="/customerstable" element={<Customers_Table />} />
          <Route path="/customermaster" element={<Customer_Master />} />
          <Route path="/customermaster/:id" element={<Customer_Master />} />
          <Route path="/suppliermaster" element={<Supplier_Master />} />
          <Route path="/suppliermaster/:id" element={<Supplier_Master />} />
          <Route path="/workermaster" element={<Worker_Master />} />
          <Route path="/workermaster/:id" element={<Worker_Master />} />
          <Route path="/workerstable" element={<Worker_Table />} />
          <Route path="/stockEntry" element={<StockEntry />} />
          <Route path="/stockEntryTable" element={<StockEntryTable />} />
          <Route path="/estimates/:product_id" element={<Estimate />} />
          <Route path="/purchase" element={<Purchase />} />
          <Route path="/purchasetable" element={<PurchaseTable />} />
          <Route path="/purchasetableold" element={<PurchaseTable1 />} />
          <Route path="/receipts" element={<Receipts />} />
          <Route path="/receipts/:id" element={<Receipts />} />
          <Route path="/orderreceipts" element={<OrderReceipts />} />
          <Route path="/orderreceipts/:id" element={<OrderReceipts />} />
          <Route path="/receiptstable" element={<ReceiptsTable />} />
          <Route path="/purchaseReport" element={<PurchaseReport />} />
          <Route
            path="/purchaseBalanceReport"
            element={<PurchaseBalanceReport />}
          />
          <Route
            path="/purchaseOrderReport"
            element={<PurchaseOrderReport />}
          />
          <Route path="/salesReport" element={<SalesReport />} />
          <Route path="/salesBalanceReport" element={<SalesBalanceReport />} />
          <Route path="/estimateReport" element={<EstimateReport />} />
          <Route path="/repairsReport" element={<RepairsReport />} />
          <Route path="/urdPurchaseReport" element={<URDPurchaseReport />} />
          <Route path="/eodDashboard" element={<EODDashboard />} />
          <Route path="/payments" element={<Payments />} />
          <Route path="/payments/:id" element={<Payments />} />
          <Route path="/paymentstable" element={<PaymentsTable />} />
          <Route path="/accounts" element={<Accounts />} />
          <Route path="/accounts/:id" element={<Accounts />} />
          <Route path="/accountstable" element={<AccountsTable />} />
          <Route path="/sales" element={<Sales />} />
          <Route path="/sales2" element={<Sales />} />
          <Route path="/metaltype" element={<MetalType />} />
          <Route path="/purity" element={<Purity />} />
          <Route path="/rates" element={<Rates />} />
          <Route path="/ratesdata" element={<RatesData />} />
          <Route path="/company_info" element={<Company_Info />} />
          <Route path="/designmaster" element={<DesignMaster />} />
          {/* <Route path="/suppliereditform/:id" element={<SupplierEditForm />}/> */}
          <Route path="/salestable" element={<SalesTable />} />
          <Route path="/urdpurchasetable" element={<URDPurchasetable />} />
          <Route path="/puritytable" element={<PurityTable />} />
          <Route path="/orderstable" element={<OrdersTable />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/barcodeprinting" element={<BarCodePrinting />} />
          <Route
            path="/sales/details/:invoice_number"
            element={<RepairDetails />}
          />

          <Route path="/salesNew" element={<SalesNew />} />

          <Route path="/salesreturn" element={<SalesReturn />} />
          <Route path="/estimatereceipt" element={<EstimateReceipt />} />

          <Route path="/accountdetails" element={<AccountDetails />} />
          <Route path="/receivables" element={<Receivables />} />
          <Route path="/usermaster" element={<UserMaster />} />
          <Route path="/usertable" element={<UserMasterTable />} />
          <Route path="/usermaster/:id" element={<UserMaster />} />
          <Route path="/subcategory" element={<SubCategory />} />
          <Route path="/subcategoryV2" element={<SubCategoryV2 />} />
          <Route path="/subcategorytable" element={<SubCategoryTable />} />
          <Route path="/festoffers" element={<Festoffers />} />
          <Route path="/festofferstable" element={<Festofferstable />} />
          <Route path="/subcategory/:id" element={<SubCategory />} />
          <Route path="/estimateSales" element={<EstimateSales />} />
          <Route path="/qrcode" element={<QRScanner />} />
          <Route path="/purchase-payment" element={<PurchasePayment />} />
          <Route path="/ratecuts" element={<RateCuts />} />
          <Route path="/itemsales" element={<ItemSales />} />
          <Route
            path="/orderstable/:order_number"
            element={<OrderProductsPage />}
          />
          <Route
            path="/vendor/:id/assignments"
            element={<VendorAssignments />}
          />
          <Route
            path="/vendor/:id/assignments/:productid"
            element={<VendorAssignments />}
          />
          <Route
            path="/vendor/:id/submissions"
            element={<VendorSubmissions />}
          />
          <Route
            path="/admin/submissions"
            element={<AdminReviews />}
          />
          <Route
            path="/admin/submissions/:productid"
            element={<AdminReviews />}
          />
          <Route
            path="/orderstable/:order_number/:vendorId/submission-view/:productId"
            element={<SubmissionView />}
          />
          <Route path="/pdf/:docType/:docId" element={<PdfGeneratorRoute />} />
        </Routes>
      </AuthProvider>
    </>
  );
}

export default function MainApp() {
  return (
    <Router>
      <App />
    </Router>
  );
}
